import { lazy } from "react";
import {
  KEY_INTERVENTION,
  TITLE_INTERVENTION,
  PATH_INTERVENTION,
  PATH_INTERVENTION_CAMPAGNE,
  KEY_INTERVENTION_CAMPAGNE,
  TITLE_INTERVENTION_CAMPAGNE,
  PATH_INTERVENTION_INTERVENTION,
  KEY_INTERVENTION_INTERVENTION,
  TITLE_INTERVENTION_INTERVENTION,
  PATH_INTERVENTION_LOT_INTERVENTION,
  KEY_INTERVENTION_LOT_INTERVENTION,
  TITLE_INTERVENTION_LOT_INTERVENTION,
  KEY_INTERVENTION_LOT_INTERVENTION_ANIMAL,
  PATH_INTERVENTION_LOT_INTERVENTION_ANIMAL,
  TITLE_INTERVENTION_LOT_INTERVENTION_ANIMAL,
  PATH_INTERVENTION_GPS,
  KEY_INTERVENTION_GPS,
  TITLE_INTERVENTION_GPS,
} from "layouts/intervention/constant/path";

import { buildRouteItem } from "router/routesUtils";

const Intervention = lazy(() => import("layouts/intervention/rubrique/intervention"));
const LotIntervention = lazy(() => import("layouts/intervention/rubrique/lot_intervention"));
const Campagne = lazy(() => import("layouts/intervention/rubrique/campagne"));
const LotAnimal = lazy(() => import("layouts/intervention/rubrique/lot_animal"));
const InterventionGps = lazy(() => import("layouts/intervention/rubrique/intervention_gps"));

const INTERVENTION_MENU_ITEMS = [
  {
    title: TITLE_INTERVENTION,
    key: KEY_INTERVENTION,
    path: PATH_INTERVENTION,
    component: Campagne,
  },
  {
    title: TITLE_INTERVENTION_CAMPAGNE,
    key: KEY_INTERVENTION_CAMPAGNE,
    path: PATH_INTERVENTION_CAMPAGNE,
    component: Campagne,
  },
  {
    title: TITLE_INTERVENTION_INTERVENTION,
    key: KEY_INTERVENTION_INTERVENTION,
    path: PATH_INTERVENTION_INTERVENTION,
    component: Intervention,
  },
  {
    title: TITLE_INTERVENTION_LOT_INTERVENTION,
    key: KEY_INTERVENTION_LOT_INTERVENTION,
    path: PATH_INTERVENTION_LOT_INTERVENTION,
    component: LotIntervention,
  },
  {
    title: TITLE_INTERVENTION_LOT_INTERVENTION_ANIMAL,
    key: KEY_INTERVENTION_LOT_INTERVENTION_ANIMAL,
    path: PATH_INTERVENTION_LOT_INTERVENTION_ANIMAL,
    component: LotAnimal,
  },
  {
    title: TITLE_INTERVENTION_GPS,
    key: KEY_INTERVENTION_GPS,
    path: PATH_INTERVENTION_GPS,
    component: InterventionGps,
  },
];

const ROUTES_INTERVENTION = [
  buildRouteItem(
    TITLE_INTERVENTION,
    KEY_INTERVENTION,
    PATH_INTERVENTION,
    INTERVENTION_MENU_ITEMS,
    // "listAltIcon"
    "medical_services"
  ),
];
export default ROUTES_INTERVENTION;
